import { linkifyText } from '../utils/linkify';
import '../css/Modal.css';

function Modal({ isOpen, onClose, title, message, type = 'info', confirmText = 'OK', onConfirm, showCancel = false, cancelText = 'Cancel', hideIcon = false, children }) {
  if (!isOpen) return null;

  // Deliberately NOT closed by a backdrop click (CLAUDE.md > Behavior).
  // This is the app-wide dialog — confirmations, "Join this session", error
  // reports — and a stray tap outside used to dismiss it silently, which is
  // worst on exactly the dialogs that were asking the user to decide
  // something. The × in the header and the footer buttons are the ways out.

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      case 'warning':
        return '⚠️';
      case 'info':
      default:
        return 'ℹ️';
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          {/* `hideIcon` is for dialogs that explain a rule rather than report
              a problem — a ⚠️ next to "here's how this add-on works" reads as
              an error the guest caused. The `type` still drives the confirm
              button's colour, so only the icon goes. */}
          {!hideIcon && <span className="modal-icon">{getIcon()}</span>}
          <h2 className="modal-title">{title}</h2>
          {/* type="button" on all three, deliberately. A button with no type
              submits, and this dialog is sometimes rendered INSIDE a form (the
              Roles tab of client registration) — where dismissing it would
              otherwise save the form behind it. */}
          <button type="button" className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          {/* Messages are plain strings assembled by callers, and several
              carry a URL an admin typed — the Open Play "Join this session"
              dialog puts a session's RSVP link here. linkifyText only ever
              splits the string and wraps matched runs in <a>, so it can't
              introduce markup from that untrusted text. */}
          {message && <p className="modal-message">{linkifyText(message)}</p>}
          {children}
        </div>
        <div className="modal-footer">
          {showCancel && (
            <button type="button" className="modal-btn modal-btn-cancel" onClick={onClose}>
              {cancelText}
            </button>
          )}
          {onConfirm ? (
            <button type="button" className={`modal-btn modal-btn-confirm modal-btn-${type}`} onClick={onConfirm}>
              {confirmText}
            </button>
          ) : (
            <button type="button" className={`modal-btn modal-btn-confirm modal-btn-${type}`} onClick={onClose}>
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Modal;